import store from "../store";

const generateShareLink = () => {

    console.log("generate share link");

    const { origin } = window.location;

    const backupData = store.getState()["visualizer"];


    var shareLink = origin + "/shared/";

    var myimage = '{}';

    var mydata = {
        backup : backupData
    }; 

    const shareData = {
        specifier:'spec',
        sel:'sel',
        url:shareLink,
        message:"Check out this design I made using the Southern Luxe Visualizer!"
    }

    // Avoid calling for actual lizard proxy if its
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortener(shareLink, "SeaGateHomes", JSON.stringify(mydata), myimage).then(function (r) {
            var arr = r.data.shortUrl.split('/');
            shareData["url"] = shareLink + arr[arr.length - 1];
            console.log(shareData);
            resolve(shareData);
            });
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve(shareData);
        });
    }
}

const loadShareLink = (code) => {
    if(origin.indexOf("localhost") === -1){
        return new Promise(function (resolve, reject) {
            window.IMWC.lizard.getShortenerData(code).then(function(r) {
                resolve(r.data)
            })
        });
    }
    else{
        return new Promise(function (resolve, reject) {
            resolve("");
        });
    }
}

export {generateShareLink, loadShareLink}

